// extracted by mini-css-extract-plugin
export default {"card":"UpcomingDataCard_card__ut76A","title":"UpcomingDataCard_title__t1t2y","label":"UpcomingDataCard_label__N33tR"};